/* eslint-disable */
// @ts-nocheck
import dash_api from '../../support/dash_api';
import NotificationActions from '../NotificationActions';
import { ReduxAsyncAction } from '../../support/utils';

const ERROR_MESSAGE = 'Failed to fetch events popularity.';
const ERROR = 'error';

const FetchEventsPopularity = new ReduxAsyncAction('FETCH_EVENTS_POPULARITY');
FetchEventsPopularity.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/analytics/events');

    return response.data;
  } catch (e) {
    NotificationActions.showNotification(ERROR_MESSAGE, ERROR);
    throw e;
  }
});
export const FETCH_EVENTS_POPULARITY: any = FetchEventsPopularity.constants;
export const fetchEventsPopularity = FetchEventsPopularity.request;
